//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpLanguage } from './op-language'

export class OpDescr implements IReferenceType, IOpChangeState, IJsonSerializable, ICopyable<OpDescr> {
    public description: string
    public extendedDescription: string
    public idDescr: number
    public idLanguage: number
    public idServer: number

    //#region Navigation Properties
    public language: OpLanguage
    //#endregion

    //#region Custom Properties
    public allLanguagesDescription: OpDescr[]
    //#endregion

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDescr
    }
    public getReferenceKey(): number {
        return this.idDescr
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idDescr = opObj.I
                this.idLanguage = opObj.IL
                this.description = opObj.D
                this.extendedDescription = opObj.E
                this.opState = opObj.O

            } else {

                this.idDescr = opObj.ID_DESCR
                this.description = opObj.DESCRIPTION
                this.extendedDescription = opObj.EXTENDED_DESCRIPTION
                this.idLanguage = opObj.ID_LANGUAGE
                this.opState = opObj.OpState
                this.idServer = opObj.ID_SERVER
                this.allLanguagesDescription = []
                if (opObj._AllLanguagesDescription != null) {
                    this.allLanguagesDescription = opObj._AllLanguagesDescription.map((descr: any) => new OpDescr(descr))
                }
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                I: this.idDescr,
                IL: this.idLanguage,
                D: this.description,
                E: this.extendedDescription,
                O: this.opState,

                __IC: 1
            }
        } else {
            return {
                ID_DESCR: this.idDescr,
                ID_LANGUAGE: this.idLanguage,
                DESCRIPTION: this.description,
                EXTENDED_DESCRIPTION: this.extendedDescription,
                OpState: this.opState,
                _AllLanguagesDescription: this.allLanguagesDescription != null ? this.allLanguagesDescription.map((descr: OpDescr) => descr.toJSON()) : null
            }
        }
    }

    public toString(): string {
        return this.description
    }

    public static restore(restoredOpObj: OpDescr) {
        if (restoredOpObj) {
            const opObj = new OpDescr()
            opObj.description = restoredOpObj.description
            opObj.extendedDescription = restoredOpObj.extendedDescription
            opObj.idDescr = restoredOpObj.idDescr
            opObj.idLanguage = restoredOpObj.idLanguage
            opObj.idServer = restoredOpObj.idServer
            opObj.opState = restoredOpObj.opState

            if (restoredOpObj.allLanguagesDescription != null) {
                opObj.allLanguagesDescription = restoredOpObj.allLanguagesDescription.map((descr: OpDescr) => {
                    return OpDescr.restore(descr)
                })
            }

            return opObj
        }
        return null
    }

    //#region ICopyable Implementation

    public copy(source: OpDescr, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {

        }

        if (includeCustomProperties) {
            if (_.size(source.allLanguagesDescription) > 0) {
                this.allLanguagesDescription = _.map(source.allLanguagesDescription, (descr: OpDescr) => {
                    const nDescr: OpDescr = new OpDescr()
                    nDescr.copy(descr, false, false, false, false)
                    return nDescr
                })
            }
        }

        if (includeDataList) {

        }

        if (includeDynamicValues) {

        }

        this.idDescr = source.idDescr
        this.description = source.description
        this.extendedDescription = source.extendedDescription
        this.idLanguage = source.idLanguage
        this.opState = source.opState
        this.idServer = source.idServer
    }

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpDescr {
        const newDescr = new OpDescr(null)

        newDescr.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newDescr
    }

    //#endregion

}